module.exports = __webpack_public_path__ + "static/img/home-bg.aa589b3c.png";